import { Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import { colorFor } from "./palette";

/** Plain vertical bars — new business by product and anything else ungrouped. */
export default function SimpleBarChart({ groups = [], colors = {}, formatValue, onGroupClick }) {
  const format = formatValue || ((v) => new Intl.NumberFormat("en-GB").format(v));
  const data = groups.map((group, index) => ({
    name: group.label,
    value: group.value,
    fill: colorFor(group.label, index, colors),
  }));

  if (!data.length) {
    return <p className="py-12 text-center text-sm text-[#4a5b68]">No records match this report.</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={320} minWidth={280}>
      <BarChart data={data} margin={{ top: 24, right: 16, left: -8, bottom: 0 }}>
        <CartesianGrid stroke="#dddddd" vertical={false} />
        <XAxis dataKey="name" tickLine={false} axisLine={false} tick={{ fill: "#4a5b68", fontSize: 12 }} interval={0} angle={data.length > 6 ? -20 : 0} textAnchor={data.length > 6 ? "end" : "middle"} height={data.length > 6 ? 60 : 30} />
        <YAxis tickLine={false} axisLine={false} tick={{ fill: "#4a5b68", fontSize: 12 }} tickFormatter={format} />
        <Tooltip
          cursor={{ fill: "rgba(15, 23, 42, 0.04)" }}
          contentStyle={{ borderRadius: 4, borderColor: "#cccccc", boxShadow: "0 4px 12px rgba(51, 71, 91, 0.12)" }}
          formatter={(value) => [format(value), "Value"]}
        />
        <Bar
          dataKey="value"
          maxBarSize={56}
          radius={[2, 2, 0, 0]}
          isAnimationActive={false}
          cursor={onGroupClick ? "pointer" : undefined}
          onClick={(entry) => onGroupClick && onGroupClick(entry?.name ?? entry?.payload?.name)}
        >
          {data.map((entry) => (
            <Cell key={entry.name} fill={entry.fill} />
          ))}
          <LabelList dataKey="value" position="top" fill="#323c44" fontSize={12} formatter={format} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
